import { Injectable } from "@angular/core";
import { CommonService } from "../services";
import { CommonStore } from "../store";
import { StorageService } from "../services/storage.service";

@Injectable({
    providedIn: "root"
})

export class InterfaceUtils {
  constructor(private _comnSvc: CommonService, private _commonStore: CommonStore, private _storageSvc: StorageService) { }
  async setInterfaceMode(TenantId, result?) {
    const reqTenantId= {
        "RequestingTenantId": TenantId+""
    }
        const response = result ? result : await this._comnSvc.getInterfacePharmSettings(reqTenantId, true).toPromise();
            if (response) {
                const isVividEnabled = this._comnSvc.getSetttingValue("RxSettings", "IS_VIVID_ENABLED") === "1" ? true : false;
                let SfaxEncryptionVector = this._comnSvc.DecryptData(localStorage.getItem('SfaxEncryptionVector'));
                const secretKey = response.applicationSharedAccessKey;
                sessionStorage.setItem("InterfaceSecretKey", this._comnSvc.encryptData(JSON.stringify(secretKey)));
                this._commonStore.storeInterfacePharmConfigSettings(response.pharmacyConfigurations);
                if (this._storageSvc.getLocalStorage("GUIDEyecon") && this._comnSvc.getDecryptLocalStorage("GUIDEyecon", false, SfaxEncryptionVector) && response.pharmacyConfigurations?.length && response.pharmacyConfigurations[0].configurationDetail?.sendData?.length) {
                    const eyconDet = response.pharmacyConfigurations[0].configurationDetail.sendData.find((machnDet: any) => ((machnDet.guid === (this._comnSvc.getDecryptLocalStorage("GUIDEyecon", false, SfaxEncryptionVector))) && machnDet.receiveMode === "I" && machnDet.active))
                    this._comnSvc.setEncryptLocalStorage("ImmediateOrPopMode", (eyconDet ? "true" : "false"), SfaxEncryptionVector)
                    this._comnSvc.setEncryptLocalStorage("EyeconIP", (eyconDet ? eyconDet.ipAddress : null), SfaxEncryptionVector);
                    this._comnSvc.setEncryptLocalStorage("popModeAssigned", (eyconDet && eyconDet.interfaceId === "2" && isVividEnabled ? "true" : "false"), SfaxEncryptionVector);
                } else {
                    this._comnSvc.setEncryptLocalStorage("ImmediateOrPopMode", "false", SfaxEncryptionVector)
                    this._comnSvc.setEncryptLocalStorage("EyeconIP", null, SfaxEncryptionVector);
                    this._comnSvc.setEncryptLocalStorage("popModeAssigned", "false", SfaxEncryptionVector);
                }
            }
    }

    setPillCounterLocalStorage(SfaxEncryptionVector, IsImmediateModeKey, guidKey, EyeconIP, popModeAssigned) {
        const isVividEnabled = this._comnSvc.getSetttingValue("RxSettings", "IS_VIVID_ENABLED") === "1" ? true : false;
        if(IsImmediateModeKey) {
            this._comnSvc.setEncryptLocalStorage("ImmediateOrPopMode", IsImmediateModeKey, SfaxEncryptionVector)
        }
        if (guidKey) {
            this._comnSvc.setEncryptLocalStorage("GUIDEyecon", guidKey, SfaxEncryptionVector)
        }
        if (EyeconIP) {
            this._comnSvc.setEncryptLocalStorage("EyeconIP", EyeconIP, SfaxEncryptionVector)
        }
        if(popModeAssigned && isVividEnabled) {
            this._comnSvc.setEncryptLocalStorage("popModeAssigned", popModeAssigned, SfaxEncryptionVector)
        }
    }
}
